export function checkOffset(offset, momentObj) {
  if (offset === 0) {
    return momentObj.unix();
  } else if (Math.sign(offset) === -1) {
    return momentObj.subtract(Math.abs(offset), 'hours').unix();
  } else {
    return momentObj.add(offset, 'hours').unix();
  }
}
